// JsFromRoutes CacheKey e969a18d4f88dea66eb24c8457aaa2ab
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const main = {
  list: definePathHelper("get", "/"),
};
